module.exports = __webpack_public_path__ + "static/media/flight_land.84053036.svg";